enum CampaignItemContextOperation {
    Delete,
    Rename,
    Duplicate,
}

export default CampaignItemContextOperation;
